import * as React from 'react';
import {ValuePropsItemsWrapper} from './ValuePropStyles';
import {language} from '../../ValuePropsSectionLanguage'
import {ValuePropType} from "../../../../../../Types/Homepage/ValuePropType";
import {
	generateValueProps,
	Props as GenerateProps
} from "../../helpers/generateValueProps";
import {ValueProp} from "./ValueProp";

export type Props = {
	valueProps: ValuePropType[],
};

export const ValuePropsItemsLayout = (props: Props) =>
{
	const render = () =>
	{
		const generateProps: GenerateProps = {
			Layout: ValueProp,
			valueProps: props.valueProps
		}
		const valueProps = generateValueProps(generateProps)
		const returnValue = (
			<ValuePropsItemsWrapper>
				{valueProps}
			</ValuePropsItemsWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
